(() => {
  if (customElements.get('judgeme-product-card-badges')) return;

  const REVIEWS_HASH = '#judgeme_product_reviews';
  const REVIEW_HASH_PATTERN = /^#(?:judgeme_product_reviews|jdgm-reviews|shopify-product-reviews)$/i;
  const BADGE_SELECTOR = '.jdgm-widget.jdgm-preview-badge[data-product-url]';
  const REVIEW_COUNT_SELECTOR =
    '.jdgm-prev-badge__text, .jdgm-preview-badge a, .jdgm-preview-badge__link';

  function isReviewHash(hash) {
    return REVIEW_HASH_PATTERN.test(hash || '');
  }

  function initJudgeMeBadges() {
    if (typeof window.jdgm === 'undefined') return;

    if (typeof window.jdgm.customInit === 'function') {
      window.jdgm.customInit();
      return;
    }

    if (window.jdgm.SHOPify && typeof window.jdgm.SHOPify.init === 'function') {
      window.jdgm.SHOPify.init();
    }
  }

  function patchBadgeLinks(root = document) {
    root.querySelectorAll(BADGE_SELECTOR).forEach((badge) => {
      const productUrl = badge.dataset.productUrl;
      if (!productUrl) return;

      badge.querySelectorAll('a[href]').forEach((link) => {
        try {
          const hash = new URL(link.href, window.location.href).hash;
          if (!isReviewHash(hash)) return;
        } catch {
          return;
        }

        link.href = `${productUrl}${REVIEWS_HASH}`;
      });
    });
  }

  class JudgeMeProductCardBadges extends HTMLElement {
    constructor() {
      super();
      this.onLoad = this.onLoad.bind(this);
      this.onBadgeClick = this.onBadgeClick.bind(this);
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.scheduleRefresh = this.scheduleRefresh.bind(this);
    }

    connectedCallback() {
      if (JudgeMeProductCardBadges.initialized) return;
      JudgeMeProductCardBadges.initialized = true;

      this.refreshBadges();
      document.addEventListener('click', this.onBadgeClick, true);
      window.addEventListener('load', this.onLoad, { once: true });
      document.addEventListener('shopify:section:load', this.onSectionLoad);
      this.setupObserver();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onBadgeClick, true);
      window.removeEventListener('load', this.onLoad);
      document.removeEventListener('shopify:section:load', this.onSectionLoad);
      this.observer?.disconnect();

      if (this.refreshFrame) {
        window.cancelAnimationFrame(this.refreshFrame);
      }

      JudgeMeProductCardBadges.initialized = false;
    }

    onLoad() {
      this.refreshBadges();
    }

    onSectionLoad() {
      this.scheduleRefresh();
    }

    scheduleRefresh() {
      if (this.refreshFrame) return;

      this.refreshFrame = window.requestAnimationFrame(() => {
        this.refreshFrame = null;
        this.refreshBadges();
      });
    }

    refreshBadges() {
      initJudgeMeBadges();
      patchBadgeLinks(document);
    }

    onBadgeClick(event) {
      if (event.button !== 0) return;

      const badge = event.target.closest(BADGE_SELECTOR);
      if (!badge) return;

      const reviewTarget = event.target.closest(REVIEW_COUNT_SELECTOR);
      if (!reviewTarget) return;

      const productUrl = badge.dataset.productUrl;
      if (!productUrl) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      window.location.assign(`${productUrl}${REVIEWS_HASH}`);
    }

    setupObserver() {
      this.observer = new MutationObserver((mutations) => {
        const hasBadgeChanges = mutations.some((mutation) => {
          if (mutation.type !== 'childList') return false;

          return [...mutation.addedNodes].some((node) => {
            if (node.nodeType !== Node.ELEMENT_NODE) return false;

            return (
              node.matches?.(BADGE_SELECTOR) ||
              node.querySelector?.(BADGE_SELECTOR)
            );
          });
        });

        if (hasBadgeChanges) {
          this.scheduleRefresh();
        }
      });

      this.observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  customElements.define('judgeme-product-card-badges', JudgeMeProductCardBadges);

  if (!document.querySelector('judgeme-product-card-badges')) {
    document.body.appendChild(document.createElement('judgeme-product-card-badges'));
  }
})();
